import type { CmsCollectionDataItem } from 'types/cms';
import { CMS } from 'client/constants/actions';

export type ActionType = { type: typeof CMS.SET_ITEMS; payload: Parameters<typeof setCollectionItems>[0] };

export function setCollectionItems(payload: { collectionId: string; items: CmsCollectionDataItem[] }): ActionType {
	return { type: CMS.SET_ITEMS, payload };
}
